/** @format */

export const newReqPart = {
  data: {
    _carVersion: '',
    _carModel: '',
    _carMaker: '',
    carMaker: '',
    carModel: '',
    carVersion: '',
    _part: '',
    optionsNum: 0,
    optionsChecked: 0,
    part: '',
    whCode: '',
    productCode: '',
    checked: 'unchecked',
    avalaible: false,
    carSide: '',
    color: '',
    notes: '',
    status: 'attivo',
    timestamp: '',
  },
  options: {},
};

export const newPartOption = {
  data: {
    _part: '',
    color: '',
    conditions: '',
    internalCode: '',
    notes: '',
    price: '',
    sold: false,
    position: '',
    checked: 'unchecked',
  },
};

export const partPositions = [
  {
    text: 'Anteriore',
    value: 'Anteriore',
  },
  {
    text: 'Anteriore/Lato Passegero',
    value: 'Anteriore/Destro',
  },
  {
    text: 'Anteriore/Lato Guidatore',
    value: 'Anteriore/Sinistro',
  },
  {
    text: 'Posteriore',
    value: 'Posteriore',
  },
  {
    text: 'Posteriore/Lato passegero',
    value: 'Posteriore/Destro',
  },
  {
    text: 'Posteriore/Lato guidatore',
    value: 'Posteriore/Sinistro',
  },
  {
    text: 'Lato passegero',
    value: 'Destro',
  },
  {
    text: 'Lato guidatore',
    value: 'Sinistro',
  },
];

export const partConditions = [
  {
    text: 'Eccellenti',
    value: 'Eccellenti',
  },
  {
    text: 'Ottime',
    value: 'Ottime',
  },
  {
    text: 'Buone',
    value: 'Buone',
  },
  {
    text: 'Discrete',
    value: 'Discrete',
  },
  {
    text: 'Necessita Riparazioni',
    value: 'Necessita Riparazioni',
  },
];
